/**
 * Keys de i18n para el modal de expiración académica.
 * Los textos viven en src/locales/en.json (fallback) y el CMS puede sobrescribirlos.
 *
 * Placeholders en mensajes: {days}, {plan}
 */
export const ACADEMIC_MODAL_TEXTS = {
  accExpiredNoticeTitle: 'account.expired.notice_title',
  accExpiredNoticeText: 'account.expired.notice_text',
  accExpiredNoticeDisclaimer: 'account.expired.notice_disclaimer',
  accExpiredRenewBtn: 'account.expired.renew_btn',
  accExpiredCancelBtn: 'account.expired.cancel_btn',
  accExpiredRemindBtn: 'account.expired.remind_btn',

  swalTermsTitle: 'account.modal.swal.terms_required_title',
  swalTermsText: 'account.modal.swal.terms_required_text',
  swalRenewalSubmittedTitle: 'account.modal.swal.renewal_submitted_title',
  swalRenewalSubmittedText: 'account.modal.swal.renewal_submitted_text',
  swalConfirmCancelTitle: 'account.modal.swal.confirm_cancel_title',
  swalConfirmCancelText: 'account.modal.swal.confirm_cancel_text',
  swalConfirmCancelBtn: 'account.modal.swal.confirm_cancel_btn',
  swalKeepAccountBtn: 'account.modal.swal.keep_account_btn',
  swalAccountCancelledTitle: 'account.modal.swal.account_cancelled_title',
  swalErrorTitle: 'account.modal.swal.error_title',
  swalOkBtn: 'account.modal.swal.ok_btn',

  modalWaitingConfirmationTitle: 'account.modal.waiting_confirmation.title',
  modalWaitingConfirmationMessage: 'account.modal.waiting_confirmation.message',
  modalReviewingTitle: 'account.modal.reviewing_application.title',
  modalReviewingMessage: 'account.modal.reviewing_application.message',
  modalAccountCancelledTitle: 'account.modal.account_cancelled.title',
  modalAccountCancelledMessage: 'account.modal.account_cancelled.message',
  modalRenewalDeniedTitle: 'account.modal.renewal_denied.title',
  modalRenewalDeniedMessage: 'account.modal.renewal_denied.message',
  modalRenewalApprovedTitle: 'account.modal.renewal_approved.title',
  modalRenewalApprovedMessage: 'account.modal.renewal_approved.message',
  modalExpiredTitle: 'account.modal.expired.title',
  modalExpiredGraceMessage: 'account.modal.expired.grace_message',
  modalExpiredNoGraceMessage: 'account.modal.expired.no_grace_message',
  modalCriticalTitle: 'account.modal.critical.title',
  modalCriticalMessage: 'account.modal.critical.message',
  modalUpgradeTitle: 'account.modal.upgrade_available.title',
  modalUpgradeMessage: 'account.modal.upgrade_available.message',

  btnViewPlans: 'account.modal.buttons.view_plans',
  btnContactSupport: 'account.modal.buttons.contact_support',
  btnCheckEmailStatus: 'account.modal.buttons.check_email_status',
  btnNoEmail: 'account.modal.buttons.no_email',
  btnUpgradePlan: 'account.modal.buttons.upgrade_plan',
  btnProcessing: 'account.modal.buttons.processing',
  btnDismiss: 'account.modal.buttons.dismiss',

  licenseAcceptPrefix: 'account.modal.license.accept_prefix',
  licenseLinkText: 'account.modal.license.link_text',
} as const;
